<template>
    <div class="goods-inner">
        <div class="goods-title">Related products</div>
        <img src="../../../../assets/image/live/close.png" class="close" @click="hide" />
        <div class="goods-box" v-if="goods && goods.length">
            <div class="goods-item" v-for="item in goods" :key="item.goods_id" @click="sendgoods(item)">
                <img class="goods-img" :src="item.goods_image" @click="goGoods(item)"/>
                <div class="goods-info">
                    <div class="name" @click="goGoods(item)">{{item.goods_name}}</div>
                    <div class="price">$ {{item.goods_price}}</div>
                </div>
                <img src="../../../../assets/image/live/cart.png" class="cart" @click="sendgoods(item)"/>
            </div>
        </div>
        <div class="empty" v-else>
          No related products
        </div>
    </div>
</template>

<script>
export default {
  props: {
    goods: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    hide () {
      this.$emit('hidegoods')
    },
    sendgoods (goods) {
      this.$emit('buy', goods)
    },
    goGoods (goods) {
      this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': goods.goods_id } })
    }
  },
  computed: {}
}
</script>
<style type="scss" scoped>
    .goods-inner {
        padding: 0 0.50625rem;
        position: absolute;
        width: 100%;
        box-sizing: border-box;
    }
    .goods-title {
        height: 2.4046875rem;
        line-height: 2.4046875rem;
        font-family: PingFangSC-Medium;
        font-size: 0.8rem;
        color: #111111;
        letter-spacing: 0;
        text-align: left;
        display: block;
        border-bottom: 1px solid #DBDBDB;
    }
    .close {
        height: 1.35rem;
        width: 1.35rem;
        position: absolute;
        right: 0.50625rem;
        top: 0.50625rem;
    }
    .goods-item {
        padding: 0.50625rem 0;
        border-bottom: 1px solid #eee;
        height: 2.953125rem;
        position: relative;
        display: flex;
    }
    .goods-box {
        padding: 0.50625rem;
        position: absolute;
        left:0;
        right: 0;
        top:2.4046875rem;
        bottom:0;
        overflow: hidden;
        overflow-y: auto;
    }
    .goods-item-img {
        width: 1.771875rem;
        height: 3.60703125rem;
        margin-top: 0.50625rem;
    }
    .goods-info {
        flex:1;
        vertical-align: middle;
        padding-left: 0.50625rem;
    }
    .goods-img {
        height: 2.953125rem;
        width: 2.953125rem;
        display: inline-block;
        vertical-align: middle;
    }
    .name {
        height: 2.3203125rem;
        font-family: PingFangSC-Medium;
        font-size: 0.7rem;
        color: #333333;
        letter-spacing: 0;
        line-height: 1.2;
    }
    .price {
        height: 0.6328125rem;
        line-height: 0.6328125rem;
        font-size: 0.7rem;
        color: #EE4E4E;
    }
    .cart{
        position: absolute;
        right: 0.50625rem;
        width: 0.759375rem;
        height: 0.759375rem;
        bottom: 0.590625rem;
    }
    .empty{text-align: center;font-size: .8rem;padding-top:1rem;}
</style>
